<template>
  <div class="page">
    <div class="page-header">
      <div class="header-left">
        <h1 class="page-title">金幣記錄</h1>
      </div>
    </div>

    <div class="layout flex-layout">
      <!-- 右側主區域 -->
      <div class="main-content">
        <!-- 手機版：學生下拉選擇器 -->
        <div class="mobile-select-user mobile-only">
          <el-select
              v-model="selectUserId"
              placeholder="選擇學生"
              clearable
              @change="handleSelectUser(selectUserId)"
              style="width:100%"
          >
            <el-option :value="null" label="全部學生"></el-option>
            <el-option
                v-for="u in userList"
                :key="u.id"
                :value="u.id"
                :label="`${u.userName}（${u.userNo}）`"
            ></el-option>
          </el-select>
        </div>

        <div class="search-card">
          <div class="search-row">
            <el-input
                v-model="listQuery.userNoLike"
                placeholder="學生賬號"
                prefix-icon="el-icon-search"
            ></el-input>
            <el-input
                v-model="listQuery.nameLike"
                placeholder="學生姓名"
                prefix-icon="el-icon-search"
            ></el-input>
            <div class="search-buttons">
              <el-button size="small" type="warning" @click="onSearch" icon="el-icon-search">搜尋</el-button>
              <el-button size="small" @click="onReset" icon="el-icon-refresh">重置</el-button>
            </div>
          </div>
        </div>

        <div class="table-container">
          <div class="pc-table">
            <el-table
                @sort-change="handleSortChange"
                :data="tableData"
                style="width:100%"
                border
                stripe
                size="small"
                :empty-text="tableData.length === 0 ? '暫無數據' : ''"
                show-summary
                :summary-method="getSummary"
            >
              <el-table-column label="#" type="index" width="50" align="center"></el-table-column>
              <el-table-column prop="userName" label="學生姓名" align="center" min-width="100"></el-table-column>
              <el-table-column prop="userNo" label="學生賬號" align="center" min-width="100"></el-table-column>
              <el-table-column prop="studentCode" label="學生編號" align="center" min-width="100"></el-table-column>
              <el-table-column prop="num" label="金幣數量" align="center" min-width="90">
                <template slot-scope="{row}">
                  <span>{{ row.num > 0 ? '+' + row.num : row.num }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="createdAt" label="發生時間" align="center" min-width="140">
                <template slot-scope="{ row }">
                  {{ formatDateTime(row.createdAt.date) }}
                </template>
              </el-table-column>
              <el-table-column prop="remark" label="備註" align="center" min-width="130">
                <template slot-scope="{ row }">
                  {{ formatRemark(row.remark) }}
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>

        <div class="pagination-wrap">
          <Pagination
              v-show="total > 0"
              :total="total"
              :page.sync="listQuery._page"
              :limit.sync="listQuery._limit"
              @pagination="getCardsUser"
          />
        </div>
      </div>
    </div>

    <deleteDialog
        titleCh="您確定要刪除此卡片嗎？"
        :centerDialogVisible="centerDialogVisible"
        @confirmFunction="confirmFunction"
        @onCancelButton="onCancelButton"
    ></deleteDialog>
  </div>
</template>

<script>
import Pagination from "@/components/Pagination";
import { getCardProperty, getCardTitle, getCardsNumUser } from "@/api/setting";
import deleteDialog from "@/components/deleteDialog";
import {getUsers} from "@/api/users";

export default {
  components: { deleteDialog, Pagination },
  data() {
    return {
      total: 0,
      staffId: null,
      centerDialogVisible: false,
      addDialogVisible: false,
      editDialogVisible: false,
      currentId: null,
      selectUserId: null,
      userList: [],
      userListTotal: 0,
      currentLocale: "zhTW",
      listQuery: {
        tagsLike: null,
        userNoLike: null,
        nameLike: null,
        parentEmailLike: null,
        studentCodeLike: null,
        gender: null,
        gradeId: null,
        orderBy: null,
        _page: 1,
        _limit: 10,
      },
      form: {
        name: '',
        titleId: null,
        propertyId: null,
        content: '',
        probability: '',
        imageUrl: '',
      },
      editForm: {
        name: '',
        titleId: null,
        propertyId: null,
        content: '',
        probability: '',
        image: '',
      },
      rules: {
        name: [{ required: true, message: '請輸入名稱', trigger: 'blur' }],
        titleId: [{ required: true, message: '請選擇主題', trigger: 'change' }],
        propertyId: [{ required: true, message: '請選擇屬性', trigger: 'change' }],
        probability: [
          { required: true, message: '請輸入概率', trigger: 'blur' }
        ]
      },
      tableData: [],
      cardTitle: [],
      cardProperty: [],
    };
  },
  watch: {
    '$t.locale'(val) {
      this.currentLocale = val;
    }
  },
  created() {
    if (this.$t && this.$t.locale) {
      this.currentLocale = this.$t.locale;
    }
    this.getCardsUser();
    this.getCardTitle();
    this.getCardProperty();
    this.getUsers();
  },
  methods: {
    getUsers() {
      let listQuery = {
        type: 2,
        tags: this.listQuery.tagsLike,
        userNoLike: this.listQuery.userNoLike,
        nameLike: this.listQuery.nameLike,
        parentEmailLike: this.listQuery.parentEmailLike,
        studentCodeLike: this.listQuery.studentCodeLike,
        branchSchoolId: this.listQuery.branchSchoolId,
        gender: this.listQuery.gender,
        gradeId: this.listQuery.gradeId,
        orderBy: this.listQuery.orderBy,
        _page: this.listQuery._page - 1,
        _limit: this.listQuery._limit,
      };
      // 清空空值参数
      Object.keys(listQuery).forEach(key => {
        if (listQuery[key] === null || listQuery[key] === undefined) {
          delete listQuery[key];
        }
      });
      getUsers(listQuery).then((v) => {
        this.userList = v.data || [];
        this.userListTotal = Number(v.headers["x-total-count"]) || 0;
      }).catch(err => {
        console.error('获取学生列表失败：', err);
        this.userList = [];
        this.userListTotal = 0;
      });
    },
    formatRemark(remark) {
      if (!remark) return '-';
      const locale = this.currentLocale;
      const map = {
        'Single Pull': { en: 'Single Pull', zhTW: '單抽' },
        '10-Pull': { en: '10-Pull', zhTW: '十連抽' },
        'Daily Login': { en: 'Daily Login', zhTW: '每日登入' },
        'Daily Reward': { en: 'Daily Reward', zhTW: '每日獎勵' },
        'Homework completed': { en: 'Homework completed', zhTW: '作業完成' },
        'Practice completed': { en: 'Practice completed', zhTW: '練習完成' },
        'Assessment completed': { en: 'Assessment completed', zhTW: '評估完成' },
        'Test completed': { en: 'Test completed', zhTW: '測驗完成' },
        'Bonus': { en: 'Bonus', zhTW: '額外獎勵' },
        'Card Purchase': { en: 'Card Purchase', zhTW: '卡牌購買' }
      };
      const item = map[remark];
      if (!item) return remark;
      return locale === 'en' ? item.en : item.zhTW;
    },
    formatDateTime(val) {
      if (!val) return '-';
      const date = new Date(val);
      if (isNaN(date.getTime())) return '-';
      const now = new Date();
      const diffMs = now.getTime() - date.getTime();
      const diffHours = diffMs / (1000 * 60 * 60);
      const diffDays = diffHours / 24;
      const rawLocale = this.currentLocale;
      if (rawLocale === 'en') {
        if (diffDays >= 30) return '1m ago';
        else if (diffDays >= 7) return '1w ago';
        else if (diffHours >= 24) return `${Math.floor(diffDays)}d ago`;
        else return `${Math.floor(diffHours)}h ago`;
      } else {
        if (diffDays >= 30) return '一月前';
        else if (diffDays >= 7) return '一周前';
        else if (diffHours >= 24) return `${Math.floor(diffDays)}天前`;
        else return `${Math.floor(diffHours)}小時前`;
      }
    },
    handleSelectUser(userId) {
      this.selectUserId = userId;
      this.listQuery.userId = userId;
      this.listQuery._page = 1;
      this.getCardsUser();
    },
    getSummary(param) {
      const { data } = param;
      const sums = [];
      sums[0] = '匯總';
      sums[1] = '';
      sums[2] = '';
      sums[3] = '';
      let totalNum = 0;
      data.forEach(item => {
        totalNum += Number(item.num || 0);
      });
      sums[4] = totalNum > 0 ? '+' + totalNum : totalNum;
      sums[5] = '';
      sums[6] = '';
      return sums;
    },
    getTitleName(titleId) {
      const item = this.cardTitle.find(t => t.id === titleId);
      return item ? item.name : '-';
    },
    getPropertyName(propertyId) {
      const item = this.cardProperty.find(p => p.id === propertyId);
      return item ? item.name : '-';
    },
    handleSortChange(col) {
      this.listQuery.orderBy = col.order ? `${col.prop} ${col.order === "descending" ? "desc" : "asc"}` : null;
      this.listQuery._page = 1;
      this.getCardsUser();
    },
    onSearch() {
      this.listQuery._page = 1;
      this.getCardsUser();
    },
    onReset() {
      Object.keys(this.listQuery).forEach(k => {
        this.listQuery[k] = null;
        if (k === "_page") this.listQuery[k] = 1;
        if (k === "_limit") this.listQuery[k] = 10;
        if (k === "userId") this.listQuery.userId = this.selectUserId;
      });
      this.getCardsUser();
    },
    onCancelButton() {
      this.centerDialogVisible = false;
    },
    confirmFunction() {},
    onDeleteButton(id) {
      this.staffId = id;
      this.centerDialogVisible = true;
    },
    getCardsUser() {
      const params = { ...this.listQuery, _page: this.listQuery._page - 1 };
      Object.keys(params).forEach(key => {
        if (params[key] == null) delete params[key];
      });
      getCardsNumUser(params).then(v => {
        this.tableData = v.data || [];
        this.total = +v.headers["x-total-count"] || 0;
      });
    },
    getCardTitle() {
      getCardTitle().then(v => {
        this.cardTitle = v.data || [];
      });
    },
    getCardProperty() {
      getCardProperty().then(v => {
        this.cardProperty = v.data || [];
      });
    }
  },
};
</script>

<style lang="scss" scoped>
.page {
  padding: 16px;
  background: #f5f7fa;
  min-height: calc(100vh - 60px);
  box-sizing: border-box;
}
.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
  padding-bottom: 12px;
  border-bottom: 1px solid #e4e7ed;
  .page-title {
    font-size: 20px;
    font-weight: 600;
    color: #B62D2E;
    margin: 0;
  }
}
.layout {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  overflow: hidden;
}
.flex-layout {
  display: flex;
  gap: 16px;
  min-height: 600px;
}
.user-sidebar {
  width: 240px;
  flex-shrink: 0;
  border-right: 1px solid #e4e7ed;
  padding: 16px;
  display: flex;
  flex-direction: column;
  .sidebar-title {
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 12px;
    color: #333;
  }
  .user-list {
    flex: 1;
    overflow-y: auto;
  }
  .user-item {
    padding: 8px 10px;
    border-radius: 4px;
    cursor: pointer;
    font-size: 14px;
    color: #606266;
    margin-bottom: 4px;
    &:hover {
      background: #f5f7fa;
    }
    &.active {
      background: #ecf5ff;
      color: #409eff;
    }
  }
}
.main-content {
  flex: 1;
  padding: 16px 16px 0 0;
  display: flex;
  flex-direction: column;
  min-width: 0;
}
.mobile-select-user {
  margin-bottom: 12px;
}
.search-card {
  background: #f8f9fa;
  padding: 16px;
  border-radius: 6px;
  margin-bottom: 20px;
  .search-row {
    display: flex;
    gap: 12px;
    flex-wrap: wrap;
    align-items: center;
    .el-input {
      flex: 1;
      min-width: 140px;
    }
    .search-buttons {
      display: flex;
      gap: 8px;
    }
  }
}
.table-container {
  width: 100%;
  overflow-x: auto;
}
.pagination-wrap {
  text-align: center;
  padding: 10px 0;
}
.mobile-only {
  display: none;
}
.desktop-only {
  display: flex;
}

@media (max-width: 768px) {
  .page {
    padding: 8px;
  }
  .flex-layout {
    flex-direction: column;
    gap: 12px;
  }
  .desktop-only {
    display: none;
  }
  .mobile-only {
    display: block;
  }
  .user-sidebar {
    width: 100%;
    border-right: none;
    border-bottom: 1px solid #e4e7ed;
  }
  .main-content {
    padding: 0 12px 0;
  }
  .search-row {
    flex-direction: column;
    align-items: stretch;
    .el-input {
      width: 100%;
    }
  }
}
</style>
